// Sandbox-host predicates. Kept outside app/bootstrap so domain-free consumers
// (e.g. src/ui) don't have to depend on the app composition root.
import { ENV_KEY } from "@app/bootstrap/init";

export const isMikeSandbox = () => ENV_KEY === "mike" || ENV_KEY === "demo";
export const isKamiliaSandbox = () => ENV_KEY === "kamilia";
